<template>
  <div>
    <div class="flex items-center justify-between">
      <label class="text-sm text-sm font-medium text-gray-900">Bank</label>
<!--      <a href="#" class="text-sm font-medium text-orange-500 hover:text-orange-600">-->
<!--        Mehr über unsere Partner erfahren-->
<!--      </a>-->
    </div>

    <RadioGroup v-model="fondsStore.selectedBank" class="mt-4" by="id">
      <RadioGroupLabel class="sr-only">Bank auswählen</RadioGroupLabel>
      <div class="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4">
        <RadioGroupOption
          as="template"
          v-for="option in fondsStore.banks"
          :key="option.id"
          :value="option"
          :disabled="false"
          v-slot="{ active, checked }"
        >
          <div
            class="cursor-pointer focus:outline-none"
            :class="[
              active ? 'ring-2 ring-orange-400 ring-offset-2' : '',
              checked
                ? 'border-transparent bg-orange-400 text-white hover:bg-orange-500'
                : 'border-gray-200 bg-white text-gray-900 hover:bg-gray-50',
              'flex items-center justify-center rounded-md border px-2 py-2 text-sm font-medium uppercase sm:flex-1'
            ]"
          >
            <RadioGroupLabel as="span">{{ option.name }}</RadioGroupLabel>
          </div>
        </RadioGroupOption>
      </div>
    </RadioGroup>
  </div>
</template>

<script setup lang="ts">
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue'
import { useFondsStore } from '@/stores/fonds'

const fondsStore = useFondsStore()
</script>
